/**
 * Utility functions for query parameter serialization and deserialization
 */

/**
 * Default serialization function
 * Handles common JavaScript types
 */
export const defaultSerialize = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  
  if (typeof value === 'boolean') {
    return value.toString();
  }
  
  if (typeof value === 'number') {
    return value.toString();
  }
  
  if (typeof value === 'string') {
    return value;
  }
  
  if (Array.isArray(value)) {
    return JSON.stringify(value);
  }
  
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  
  return String(value);
};

/**
 * Default deserialization function
 * Attempts to parse common JavaScript types
 */
export const defaultDeserialize = (value) => {
  if (value === '' || value === null || value === undefined) {
    return '';
  }
  
  // Handle special empty values
  if (value === 'null') return null;
  if (value === 'undefined') return undefined;
  
  // Try to parse as JSON first (for arrays and objects)
  if (value.startsWith('[') || value.startsWith('{')) {
    try {
      return JSON.parse(value);
    } catch {
      // Fall through to string handling
    }
  }
  
  // Try to parse as number
  if (!isNaN(value) && value.trim() !== '' && !isNaN(parseFloat(value))) {
    const num = parseFloat(value);
    // Return as integer if it's a whole number
    return Number.isInteger(num) ? parseInt(value, 10) : num;
  }
  
  // Try to parse as boolean
  if (value === 'true') return true;
  if (value === 'false') return false;
  
  // Return as string
  return value;
};
